import { monthEndAlertConstants } from '../../actions/constant';

const {
  GET_OWNER_ALERT_COUNT_REQUEST,
  GET_OWNER_ALERT_COUNT_SUCCESS,
  GET_OWNER_ALERT_COUNT_FAILURE,
} = monthEndAlertConstants;

const intitialstate: object = {
  response: null,
  isError: false,
  loading: false,
};

export const getOwnerAlertCountReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_OWNER_ALERT_COUNT_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }
    case GET_OWNER_ALERT_COUNT_FAILURE:
      return {
        ...state,
        isError: true,
        response: null,
        loading: false,
      };
    case GET_OWNER_ALERT_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        isError: false,
      };
    default:
      return state;
  }
};
